import { Main } from "@/components/Main";
import { If } from "@/components/If";
import { usePermissions } from "@/hooks/usePermissions";
import { Dashboard } from "@/App/Dashboard";
import { Loader2 } from "lucide-react";

export const DashBoard = () => {
  const { hasPermission, loading } = usePermissions();

  if (loading) {
    return (
      <Main>
        <div className="flex items-center justify-center h-64">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
        </div>
      </Main>
    );
  }

  return (
    <Main>
      <If condition={hasPermission("view-dashboard")}>
        <div className="pt-4">
          <Dashboard />
        </div>
      </If>
    </Main>
  );
};
